export function openForm ({ commit }, event) {
	commit(`openForm`, event);
	commit(`vcl/overlay/open`, undefined, { root: true });
}
